import { collectCoveragesPendingEoi } from 'enrollment/features/EOI/components';
import { getHasPluginEoi } from 'enrollment/features/ToDoList/services';
import { BenefitsPageResponseDto, EoiContextsDto } from 'theSource/queries';

export const isWaitingForEoi = (benefitsData?: BenefitsPageResponseDto) => {
  let waitingForPluginEoi = false;

  const eoiData =
    benefitsData?.data.eoi ||
    ({ past: {}, current: {}, next: {} } as EoiContextsDto);
  waitingForPluginEoi = getHasPluginEoi(eoiData);

  const coveragesPendingEoi = collectCoveragesPendingEoi(benefitsData?.data);

  return (
    waitingForPluginEoi ||
    coveragesPendingEoi.current.length > 0 ||
    coveragesPendingEoi.next.length > 0
  );
};
